<template>
    <div v-if="visible">
        <div class="modal-backdrop">

        </div>
        <div class="modal">
            <div class="modal-header">
                <h4 class="modal-title">{{$t('components.administration.failed-orders.data-editor')}}</h4>
                <button class="btn-close" @click="close">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row" v-if="target.type === 'SHOPORD' || target.type === 'STOCK_FIFO' || target.type === 'STOCK_ETA'">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>{{$t('components.administration.orders.concrete.uniqueId')}}</label>
                            <input type="text" v-model="target.unique_id" class="form-control form-control-sm">
                        </div>
                    </div>
                </div>
                <div class="row" v-if="target.type !== 'PRODUCT' && target.type !== 'OTHER'">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>{{$t('components.administration.orders.concrete.itemData')}}</label>
                            <textarea class="form-control form-control-sm" v-model="target.item_data" rows="10"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="target.type === 'PRODUCT' && target.configuration !== '*'">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label>{{$t('components.administration.orders.concrete.configuration')}}</label>
                            <textarea class="form-control form-control-sm" v-model="target.configuration" rows="10"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "FailedOrderItemEditorModal",
    props: {
        visible: Boolean,
        target: Object
    },

    methods: {
        close() {
            this.$emit('close');
        },
    },

    watch: {
        visible: function (val) {
            if (val) {
                this.target.item_data = JSON.stringify(JSON.parse(this.target.item_data), null, 2);
                if (this.target.configuration !== '*') {
                    this.target.configuration = JSON.stringify(JSON.parse(this.target.configuration), null, 2);
                }
            }
        },
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99998;
}

.modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: block;
    margin: 15px auto 15px auto;
    height: calc(100vh - 50px);
    width: calc(100vw - 60vw);
    z-index: 99999;
}

.modal-header,
.modal-footer {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #b89453;
    justify-content: space-between;
}

.modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: calc(100vh - 152px);
}

.btn-close {
    border: none;
    font-size: 36px;
    cursor: pointer;
    font-weight: bold;
    color: #b89453;
    background: transparent;
}
</style>
